module.exports = __webpack_public_path__ + "img/country.1bb275bb.png";